import React from 'react';

export default React.createContext({
  dispatch: () => { },
  color: {},
});
